import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";

import Header from "../header/Header";
import Footer from "../footer/Footer";
import NotificationBar from "../modules/notificationBar/NotificationBar";
import stylingOptions from "@v4/utils/stylingOptions";
import * as layoutStyles from "./layout.module.css";
import { useGlobalNotificationBars } from "@v4/gatsby-theme-talend/src/components/modules/notificationBar/useGlobalNotificationBars";
import TempPageProvider from "@v4/gatsby-theme-talend/src/components/TempPageProvider";
const cx = classNames.bind(layoutStyles);

const Layout = ({ children, headerMenu, footerMenu, hasMinimalNav, notificationBar, pageStyleProps }) => {
    const pageStyleOpts = stylingOptions(pageStyleProps, cx) ?? "";

    // Adding wrapper ref for Notification Bar
    const pageWrapperRef = useRef();

    const globalNotificationBar = useGlobalNotificationBars();

    const notificationBarData = globalNotificationBar ?? notificationBar ?? null;

    return (
        <TempPageProvider data={{}}>
            <div id="pageWrapper" ref={pageWrapperRef}>
                <div className={cx("topRegion")}>
                    {notificationBarData && (
                        <NotificationBar {...notificationBarData.props} pageWrapperRef={pageWrapperRef} />
                    )}
                    <Header headerMenu={headerMenu} />
                </div>
                <div className="wrapper pageInterior">
                    <main id="main" className={cx(`${pageStyleOpts && pageStyleOpts.classString}`)}>
                        {children}
                        {pageStyleOpts && pageStyleOpts.bgImageEl}
                    </main>
                    <Footer {...footerMenu} hasMinimalNav={hasMinimalNav} />
                </div>
            </div>
        </TempPageProvider>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
